"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceStringValues = exports.camelCaseToSentenceCase = exports.CHECK_IN_CATEGORY = exports.getResponseErrorCode = exports.delay = exports.networkStatusIsLoading = exports.phoneNumberIsTestAccount = exports.formatISODate = exports.formatDate = exports.formatCurrency = exports.formatNumber = void 0;
const lodash_1 = require("lodash");
const moment_1 = __importDefault(require("moment"));
const currency_1 = require("./currency");
__exportStar(require("./timeBetween"), exports);
__exportStar(require("./currency"), exports);
__exportStar(require("./format"), exports);
__exportStar(require("./validate"), exports);
__exportStar(require("./phoneNumbers"), exports);
__exportStar(require("./reminders"), exports);
const FORMAT_DATE_STRING = "YYYY-MM-DD";
const POSITIVE_NUMBER = 1;
const NEGATIVE_NUMBER = -1;
const POSITIVE_ZERO = 0;
const NEGATIVE_ZERO = -0;
const TWO = 2;
function formatNumber(value, positive, negative) {
  switch (Math.sign(value)) {
    case POSITIVE_NUMBER:
    case POSITIVE_ZERO:
      return positive(value);
    case NEGATIVE_NUMBER:
    case NEGATIVE_ZERO:
      return negative(value);
    default:
      throw new Error("Invalid number");
  }
}
exports.formatNumber = formatNumber;
const formatCurrency = function (amount) {
  let currencyString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "USD";
  let decimalPlaces = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TWO;
  const currencySymbol = (0, currency_1.currencySymbolForString)(currencyString);
  return formatNumber(amount, value => "".concat(currencySymbol).concat(Math.abs(value).toFixed(decimalPlaces)), value => "-".concat(currencySymbol).concat(Math.abs(value).toFixed(decimalPlaces)));
};
exports.formatCurrency = formatCurrency;
const formatDate = (formatString, date) => (0, moment_1.default)(date).format(formatString);
exports.formatDate = formatDate;
const formatISODate = function () {
  let date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  return (0, exports.formatDate)(FORMAT_DATE_STRING, date);
};
exports.formatISODate = formatISODate;
var validate_1 = require("./validate");
Object.defineProperty(exports, "phoneNumberIsTestAccount", {
  enumerable: true,
  get: function () {
    return validate_1.validateTestAccountPhoneNumber;
  }
});
const networkStatusIsLoading = networkStatus => networkStatus < 7;
exports.networkStatusIsLoading = networkStatusIsLoading;
const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
exports.delay = delay;
const getResponseErrorCode = response => (0, lodash_1.get)(response, "errors[0].errcode", undefined);
exports.getResponseErrorCode = getResponseErrorCode;
exports.CHECK_IN_CATEGORY = Object.freeze({
  MEDICATION: "MEDICATION",
  MEAL: "MEAL",
  WEIGHT: "WEIGHT",
  GLUCOSE: "GLUCOSE",
  BLOOD_PRESSURE: "BLOOD_PRESSURE",
  PULSE_OX: "PULSE_OX",
  STEPS: "STEPS",
  SLEEP: "SLEEP"
});
const camelCaseToSentenceCase = str => {
  const result = str.replace(/([A-Z])/g, " $1");
  const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  return finalResult;
};
exports.camelCaseToSentenceCase = camelCaseToSentenceCase;
const replaceStringValues = (str, replaceMap) => {
  if ((0, lodash_1.isEmpty)(replaceMap)) {
    return str;
  }
  const regex = new RegExp(Object.keys(replaceMap).map(value => "<".concat(value, ">")).join("|"), "gi");
  return str.replace(regex, matched => {
    const replacement = replaceMap[matched.slice(1, -1)];
    return replacement || replacement === 0 ? replacement : "";
  });
};
exports.replaceStringValues = replaceStringValues;